export interface GroupedBySign<T> {
  sign: string;
  rows: T[];
}

export function groupBySign<T extends { sign?: string }>(data: T[]): GroupedBySign<T>[] {
  const map: Record<string, T[]> = {};

  for (const item of data) {
    const signKey = item.sign ?? 'Unknown';

    if (!map[signKey]) {
      map[signKey] = [];
    }

    map[signKey].push(item);
  }

  return Object.entries(map).map(([sign, rows]) => ({
    sign,
    rows,
  }));
}
